import { FormattedMessage } from 'react-intl'

import { Typography } from '@gto/ui/typography'

/**
 * The verbatim 2026 Affiliate Partnership Agreement: intro, grandfather clause,
 * ten numbered sections, and the sign-off. Section order and message ids match
 * the legal source — do not reorder or paraphrase; copy lives in `en.json` under
 * `terms.*`.
 */
const SECTION_IDS = [
  'commission',
  'referredUserDiscount',
  'payments',
  'promotionalStandards',
  'dataPrivacy',
  'productAccess',
  'tierReviews',
  'attribution',
  'termination',
  'promotionalCampaigns',
] as const

export const AgreementText = () => {
  return (
    <div className="flex flex-col gap-6">
      <Typography
        color="text.secondary"
        variant="body2"
      >
        <FormattedMessage id="terms.intro" />
      </Typography>

      <Typography
        color="text.secondary"
        variant="body2"
      >
        <FormattedMessage id="terms.grandfather" />
      </Typography>

      {SECTION_IDS.map((section) => (
        <div
          key={section}
          className="flex flex-col gap-1"
        >
          <Typography
            className="font-bold"
            color="text.primary"
            variant="body2"
          >
            <FormattedMessage id={`terms.section.${section}.heading`} />
          </Typography>
          <Typography
            color="text.secondary"
            variant="body2"
          >
            <FormattedMessage id={`terms.section.${section}.body`} />
          </Typography>
        </div>
      ))}

      <Typography
        className="mt-2 font-bold"
        color="text.primary"
        variant="body2"
      >
        <FormattedMessage id="terms.signOff" />
      </Typography>
    </div>
  )
}
